jQuery(document).foundation();

(function ($) {

  /**
   * Mobile Menu
   */
  var $body = $('html,body');
  var $mobileMenu = $('.mobile-menu-trigger');
  var $mobileButtonBar = $mobileMenu.find('.bar');
  var menuActive = false;

  $mobileMenu.on('click', function (e) {
    e.preventDefault();

    if (!menuActive) {
      menuActive = true;
      openMobileMenu();
    } else {
      menuActive = false;
      closeMobileMenu();
    }
  });

  $('.mobile-menu__nav').on('click', 'a', function() {
    menuActive = false;
    closeMobileMenu();
  });

  // Open Menu
  function openMobileMenu() {
    var buttonTl = window.anime.timeline({
      easing: 'easeInOutCubic',
      duration: 500,
      complete: function() {
        $mobileMenu.addClass('active');
      }
    });

    buttonTl.add({
      targets: $mobileButtonBar.eq(0).get(0),
      keyframes: [
        {
          translateY: [0, 6],
        },
        {
          rotate: 45,
        }
      ]
    });
    buttonTl.add({
      targets: $mobileButtonBar.eq(1).get(0),
      opacity: [1, 0]
    }, 0);
    buttonTl.add({
      targets: $mobileButtonBar.eq(2).get(0),
      keyframes: [
        {
          translateY: [0, -6],
        },
        {
          rotate: -45,
        },
      ],
    }, 0);

    var menuTl = window.anime.timeline({
      easing: 'easeInOutCubic',
    });

    menuTl.add({
      duration: 500,
      opacity: [0, 1],
      targets: '.js-mobile-menu',
      begin: function() {
        $body.addClass('mobile-menu-opened');
      }
    });
    menuTl.add({
      duration: 250,
      opacity: [0, 1],
      translateY: ['50%', '0%'],
      delay: anime.stagger(120),
      targets: '.mobile-menu__nav li',
    })
  }

  // Close Menu
  function closeMobileMenu() {
    var buttonTl = window.anime.timeline({
      easing: 'easeInOutCubic',
      duration: 500,
      complete: function() {
        $mobileMenu.addClass('active');
      }
    });

    buttonTl.add({
      targets: $mobileButtonBar.eq(0).get(0),
      keyframes: [
        {
          rotate: [45, 0],
        },
        {
          translateY: [6, 0],
        },
      ]
    });
    buttonTl.add({
      targets: $mobileButtonBar.eq(1).get(0),
      opacity: [0, 1]
    }, 0);
    buttonTl.add({
      targets: $mobileButtonBar.eq(2).get(0),
      keyframes: [
        {
          rotate: [-45, 0],
        },
        {
          translateY: [-6, 0],
        },
      ],
    }, 0);

    var menuTl = window.anime.timeline({
      easing: 'easeInOutCubic',
    });

    menuTl.add({
      duration: 250,
      opacity: [1, 0],
      translateY: ['0%', '-50%'],
      delay: anime.stagger(120),
      targets: '.mobile-menu__nav li',
    });
    menuTl.add({
      duration: 500,
      opacity: [1, 0],
      targets: '.js-mobile-menu',
      complete: function() {
        $body.removeClass('mobile-menu-opened');
      }
    });
  }

  /**
   * Logo click event
   */
  $('.site-logo').on('click', 'a', function(e) {
    e.preventDefault();
    if (menuActive) {
      menuActive = false;
      closeMobileMenu();
    }
    $('html,body').animate({
      scrollTop: 0,
    })
  });

  /**
   * On scroll until reach threshold, set logo height for mobile
   */
  $(window).on('scroll', function(e) {
    var scrollPos = $(window).scrollTop()
    var $siteHeader = $('.site-header')

    if (scrollPos >= 100) {
      $siteHeader.addClass('mobile-stuck')
    } else {
      $siteHeader.removeClass('mobile-stuck')
    }
  })

  /**
   * Set height of hero block
   * The height of the block already defined by css. But on mobile there is bug when using 100vh
   * So the height need to be calculated
   */
  function calculateHeroBlockHeight() {
    $('.block-hero').css({
      height: $(window).innerHeight(),
    });
  }
  calculateHeroBlockHeight();

  $(window).on('resize', $.debounce(250, calculateHeroBlockHeight));

  /**
   * Hero section button click
   */
  $('.block-hero').on('click', function(e) {
    e.preventDefault()
    $('html,body').animate({
      scrollTop: $('.block-hero').next().offset().top - 50,
    })
  });

})(jQuery)
